module.exports = __webpack_public_path__ + "static/box-recipe.9ecabb0c.jpg";